import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "Medlar Media",
    category: "web",
    link: "https://medlar-media.netlify.app",
  },
  {
    id: 2,
    image: Work2,
    title: "LinkedIn with ReactJS",
    category: "web",
    link: "https://linkedin-h.netlify.app",
  },
  {
    id: 3,
    image: Work3,
    title: "Youtube with ReactJS",
    category: "web",
    link: "https://youtube-h.netlify.app",
  },
  {
    id: 4,
    image: Work4,
    title: "Netflix with ReactJS",
    category: "web",
    link: "https://netflix-h-2.netlify.app",
  },
  // {
  //   id: 5,
  //   image: Work5,
  //   title: "Web design",
  //   category: "web",
  // },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  // {
  //   name: "client",
  // },
];
